import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { accountService } from "../../_services/accounts.service";
import { UserProfileCurrentForm } from "./userProfile-currentForm";
import { UserProfileOfficialLicenseList } from "./userProfile-officialLicenseList";
import { UserProfileOfficialNoteList } from "./userProfile-officialNoteList";


export function UserProfileOfficialLicenseIndex(params: {}) {

    return (
        <>
            <UserProfileCurrentForm currentForm={FormTemplateTypeEnum.Official} />
            <UserProfileOfficialLicenseList />
            
            {accountService.isAdmin &&
                <div style={{ marginTop: "30px" }}>
                    <UserProfileOfficialNoteList />
                </div>
            }
        </>
    );
}